import React from 'react';
import css from './ProfilePage.module.css';
import Icons from '../../components/Icons/Icons';
import { FormattedMessage } from 'react-intl';

import {
  inhouseConsultantsOptions,
  designScopeOptions,
  energySolutionsOptions,
} from '../../util/general';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';
import { H4 } from '../../components';

const renderArraySection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;

  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, i) => (
          <div key={i} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const renderSingleValueSection = (headingId, value, options) => {
  if (!value) return null;

  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {getLabelFromKey(value, options)}
        </div>
      </div>
    </>
  );
};

const DesignOptionsSection = ({ publicData = {} }) => {
  const { inhouseConsultants, designScope, energySolutions, specifyDesignScope } = publicData;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.designOptions" />
      </h2>
      {renderSingleValueSection(
        'ProfilePage.inhouseConsultants.heading',
        inhouseConsultants,
        inhouseConsultantsOptions
      )}

      {renderArraySection('ProfilePage.designScope.heading', designScope, designScopeOptions)}

      {renderArraySection(
        'ProfilePage.energySolutions.heading',
        energySolutions,
        energySolutionsOptions
      )}
      {specifyDesignScope && (
        <>
          <H4 as="h4">
            <FormattedMessage id="ProfilePage.designScope.specifyDesignScope" />
          </H4>
          <div className={css.serviceList}>
            <div className={css.service}>
              <Icons name="check" /> {specifyDesignScope}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DesignOptionsSection;
